import React, { useState, useContext } from "react";
import { X, UploadCloud, FileText } from "lucide-react";
import { UserContext } from "../../../context/UserContext";
import UploadSuccessPopup from "../../common/UploadSuccessPopup";
import { uploadPrescriptionApi } from "../../../services/HomePage/PrescriptionApi";

export default function UploadPrescriptionSlider({ isOpen, onClose }) {
  const { user } = useContext(UserContext);

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  if (!isOpen) return null;

  // ================= FILE CHANGE =================
  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    console.log("📂 SELECTED FILE:", selected);
    setFile(selected);
  };

  // ================= UPLOAD =================
  const handleUpload = async () => {

    if (!file) {
      alert("Please select a file");
      return;
    }

    console.log("👤 USER DATA:", user);

    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("UserId", Number(user?.userId));
      formData.append("Phone", String(user?.identifier));
      formData.append("Status", true);
      formData.append("Created_By", String(user?.userId));
      formData.append("File", file);

      // ✅ DEBUG FORM DATA
      console.log("📤 SENDING DATA:");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      // ✅ API CALL
      const res = await uploadPrescriptionApi(formData);

      console.log("🎉 FINAL RESPONSE:", res);

      setShowSuccess(true);

    } catch (err) {

      console.log("❌ FULL ERROR:", err);
      console.log("❌ RESPONSE:", err?.response);
      console.log("❌ DATA:", err?.response?.data);

      alert("Upload failed");

    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="fixed inset-0 z-[9999] flex justify-end bg-black/50 backdrop-blur-sm">

        {/* SLIDER */}
        <div className="w-full md:w-[420px] h-full bg-white shadow-2xl p-6 relative flex flex-col">

          {/* HEADER */}
          <div className="flex items-center justify-between mb-5">
            <h2 className="text-xl font-bold text-gray-800">
              Upload Prescription
            </h2>
            <button onClick={onClose}>
              <X className="text-gray-500 hover:text-red-500" />
            </button>
          </div>

          {/* INFO */}
          <div className="bg-gradient-to-r from-red-50 to-pink-50 p-4 rounded-xl shadow-sm border">

            <p className="font-semibold text-sm mb-3 text-gray-700">
              What is a valid prescription?
            </p>

            <div className="bg-white p-3 rounded-lg mb-3 shadow-sm text-xs text-gray-500 space-y-1">
              <p>✔ Doctor’s details</p>
              <p>✔ Date of prescription</p>
              <p>✔ Patient details</p>
              <p>✔ Medicines</p>
            </div>

            <ul className="text-xs text-gray-600 space-y-1">
              <li>• Supported: PNG, JPEG, PDF</li>
              <li>• Max size: 5MB</li>
            </ul>
          </div>

          {/* FILE BOX */}
          <div className="mt-6 flex-1">

            <label className="flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-xl h-40 cursor-pointer hover:border-red-400 transition">

              <UploadCloud className="text-gray-400 mb-2" size={32} />

              <p className="text-sm text-gray-600">
                Click to upload or drag file
              </p>

              <p className="text-xs text-gray-400 mt-1">
                PNG, JPG, PDF
              </p>

              <input
                type="file"
                accept=".png,.jpg,.jpeg,.pdf"
                onChange={handleFileChange}
                className="hidden"
              />
            </label>

            {/* FILE NAME */}
            {file && (
              <div className="mt-3 flex items-center gap-2 text-sm text-gray-700 bg-gray-100 px-3 py-2 rounded-lg">
                <FileText size={16} />
                {file.name}
              </div>
            )}

          </div>

          {/* BUTTON */}
         <div className="sticky bottom-0 bg-white pt-4">
  <button
    onClick={handleUpload}
    disabled={loading}
    className="w-full bg-gradient-to-r from-green-500 to-emerald-500 text-white py-3 rounded-xl font-semibold shadow-md hover:scale-[1.02] transition"
  >
    {loading ? "Uploading..." : "⬆ Upload Prescription"}
  </button>
</div>

        </div>
      </div>

      {/* SUCCESS POPUP */}
      <UploadSuccessPopup
        isOpen={showSuccess}
        onClose={() => {
          setShowSuccess(false);
          onClose();
        }}
      />
    </>
  );
}